<template>
  <v-row>
    <v-col cols="11" sm="5">
      <v-menu
        ref="menu"
        v-model="timeMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-row>
            <v-col cols="2" sm="2" md="2">
              <v-text-field
                hidden
                v-model="time"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
            <v-col cols="10" sm="10" md="10">
              <v-text-field
                v-model="textTime"
                v-bind="attrs"
                v-on="on"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <v-time-picker
          v-if="timeMenu"
          v-model="time"
          format="ampm"
          @click:minute="$refs.menu.save(time)"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  computed: {
    ...mapFields("shared", ["selectedTime", "selectedDateTime"]),
  },
  data: () => ({
    time: null,
    textTime: "",
    UTCTime: "",
    AM_PM: "",
    timePeriod: "",
    timeMenu: false,
    menu: false,
    textTime: null,
    date: new Date().toISOString().substr(0, 10),
  }),
  methods: {
    ...mapActions("shared", ["timeSelected"]),
  },
  props: {
    TimeStamp: {
      type: Number,
      required: false,
    },
  },
  watch: {
    time: {
      immidate: false,
      handler(value) {
        var hour, minute;

        hour = parseInt(value.split(":")[0]);
        minute = value.split(":")[1].toString();
        // set the AM/PM to the string text
        if (hour < 12) {
          hour = hour.toString() + ":" + minute;
          this.AM_PM = "AM";
          this.textTime = hour + this.AM_PM;
          this.UTCTime = value + ":00";
        } else {
          if (hour === 12) {
            hour = hour.toString() + ":" + minute;
            this.AM_PM = "PM";
            this.textTime = hour + this.AM_PM;
            this.UTCTime = value + ":00";
          } else {
            hour = hour - 12;
            hour = hour.toString() + ":" + minute;
            this.AM_PM = "PM";
            this.textTime = hour + this.AM_PM;
            this.UTCTime = value + ":00";
          }
        }

        this.timePeriod = this.AM_PM;
        this.timeSelected({
          payload: {
            time: this.UTCTime,
          },
        });
      },
    },
    TimeStamp: {
      immidate: true,
      handler(value) {
        this.textDate = value;
        var iso,time, utc, date;
        iso = moment.utc(value * 1000).format(); 
        utc = moment(iso).format("dddd, MMMM Do YYYY, h:mm:ss a").split(","); 
        time = utc[2].toString();
        this.textTime = time; 
      },
    },
  },
};
</script>